import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';

export const MARK_ATTACHMENTS_AS_READ = gql`
  mutation markAttachmentsAsRead($input: PRAA_MarkAttachmentsAsReadInput!) {
    markAttachmentsAsRead(input: $input)
  }
`;

export const useMarkAttachmentsAsRead = () => {
  const [markAttachmentsAsRead] = useMutation(MARK_ATTACHMENTS_AS_READ);

  return {
    markAttachmentsAsRead: ({ binaryObjectUris }) =>
      markAttachmentsAsRead({
        variables: {
          input: {
            binaryObjectUris
          }
        }
      })
  };
};

export default useMarkAttachmentsAsRead;
